import { render, staticRenderFns } from "./modalDoubleReward.vue?vue&type=template&id=c4d04b18&scoped=true"
import script from "./modalDoubleReward.vue?vue&type=script&lang=js"
export * from "./modalDoubleReward.vue?vue&type=script&lang=js"
import style0 from "./modalDoubleReward.vue?vue&type=style&index=0&id=c4d04b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d04b18",
  null
  
)

export default component.exports